import { noop } from '@kofno/piper';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import Label from '../../../../../../Resource/FormTemplates/Inputs/Label';
import MultipleSelectionsInput from '../../../../../../Resource/FormTemplates/Inputs/MultipleSelectionsInput';
import { SingleSelectionField } from '../../../../../../Resource/FormTemplates/Types';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import { Ready } from '../Types';
import GroupInfo from './GroupInfo';

interface Props {
  field: SingleSelectionField;
  submitting: () => void;
  state: Ready;
}

function Form({ field, submitting, state }: Props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submitting();
      }}
    >
      <Label field={field} />
      <MultipleSelectionsInput field={field} />
      <div className="pt-8 font-semibold">
        <T kind="Groups to be Allocated" />
      </div>
      {state.multicheckStore.selected.map((group) => (
        <GroupInfo key={group.payload.id} group={group} />
      ))}
      <p
        className={clsx(
          'mt-4 mb-12 rounded border-1 border-solid border-teal-400 bg-teal-500 px-4 py-3',
          'text-sm text-gray-800',
        )}
      >
        <T kind="Group members are not notified when licenses are allocated..." />
      </p>
      <Button
        type="submit"
        value="Submit"
        onClick={noop}
        data-intercom-target="add-license-to-groups-submit"
        className={clsx(
          'rounded-md border border-solid border-gray-900 bg-white',
          'py-2.5 px-5 text-sm font-semibold text-gray-900',
        )}
      />
    </form>
  );
}

export default observer(Form);
